module.exports = __webpack_public_path__ + "img/drag.a4135fdb.svg";